var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("Page Not Found")]),_c('p',[_vm._v("\n      We can’t seem to find the page you’re looking for…\n    ")])])])
}]

export { render, staticRenderFns }